import { useCallback, useState } from 'react';
import './DeleteReport.scss';

import { ExitIcon } from '../../shared/Icons/index';
import { Button } from '../../shared/button/Button';

interface DeleteReportProps {
  dashboardName: string;
  handleCancel: () => void;
  handleDelete: () => Promise<void>;
}

export const DeleteReport = (props: DeleteReportProps) => {
  const { dashboardName, handleCancel, handleDelete } = props;
  const [isLoading, setIsLoading] = useState(false);
  const handleCloseModal = useCallback(() => {
    handleCancel();
  }, [handleCancel]);

  const handleDeleteReport = async () => {
    try {
      setIsLoading(true);
      await handleDelete();
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <section className='delete-report-container opened'>
      <dialog open={true} className='modal'>
        <header>
          <h2>{`Delete ${dashboardName}?`}</h2>
          <button onClick={handleCloseModal} data-testid='close-button'>
            <ExitIcon />
          </button>
        </header>
        <main>
          <p>Are you sure you want to delete {dashboardName}?</p>

          <div className='buttons-container'>
            <Button
              lKey='Cancel'
              type='button'
              className='cancel-button'
              onClick={handleCloseModal}
              datatestid='cancel-button'
              isDisabled={isLoading}
            />

            <Button
              lKey='Delete'
              type='button'
              className='delete-button'
              datatestid='delete-button'
              isDisabled={false}
              isLoading={isLoading}
              onClick={async () => handleDeleteReport()}
            />
          </div>
        </main>
      </dialog>
    </section>
  );
};
